/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import boxShadows from "assets/theme-dark/base/boxShadows";
import typography from "assets/theme-dark/base/typography";
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
import rgba from "assets/theme-dark/functions/rgba";

const { md } = boxShadows;
const { size } = typography;
const { transparent, light, gradients, white } = colors;
const { borderRadius } = borders;

const autocomplete = {
  styleOverrides: {
    popper: {
      boxShadow: md,
      padding: pxToRem(8),
      fontSize: size.sm,
      color: "var(--app-text-primary)",
      textAlign: "left",
      backgroundColor: "var(--app-surface) !important",
      borderRadius: borderRadius.md,
      border: "1px solid var(--app-border)",
    },

    paper: {
      boxShadow: "none",
      backgroundColor: transparent.main,
    },

    root: {
      "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
        backgroundColor: "var(--app-field-bg)",
        color: "var(--app-field-text)",
      },
      "& .MuiInputBase-input, & .MuiAutocomplete-input": {
        color: "var(--app-field-text) !important",
        WebkitTextFillColor: "var(--app-field-text) !important",
        caretColor: "var(--app-field-text) !important",
      },
      "& .MuiInputBase-input::placeholder, & .MuiAutocomplete-input::placeholder": {
        color: "var(--app-field-placeholder) !important",
        opacity: 1,
      },
      "& .MuiInputLabel-root": {
        color: "var(--app-text-secondary)",
      },
      "& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator": {
        color: "var(--app-icon-color)",
      },
    },

    option: {
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: "var(--app-text-primary)",
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: rgba(light.main, 0.2),
        color: white.main,
      },

      '&[aria-selected="true"]': {
        backgroundColor: `${rgba(light.main, 0.2)} !important`,
        color: `${white.main} !important`,
      },
    },

    noOptions: {
      fontSize: size.sm,
      color: "var(--app-text-primary)",
    },

    groupLabel: {
      color: "var(--app-text-primary)",
    },

    loading: {
      fontSize: size.sm,
      color: "var(--app-text-primary)",
    },

    tag: {
      display: "flex",
      alignItems: "center",
      height: "auto",
      padding: pxToRem(4),
      backgroundColor: gradients.dark.state,
      color: white.main,

      "& .MuiChip-label": {
        lineHeight: 1.2,
        padding: `0 ${pxToRem(10)} 0 ${pxToRem(4)}`,
      },

      "& .MuiSvgIcon-root, & .MuiSvgIcon-root:hover, & .MuiSvgIcon-root:focus": {
        color: white.main,
        marginRight: 0,
      },
    },

    popupIndicator: {
      color: "var(--app-icon-color)",
    },

    clearIndicator: {
      color: "var(--app-icon-color)",
    },
  },
};

export default autocomplete;
